import { z } from 'zod/v4';

export const clientSchema = z.object({
  code: z.string().min(1, 'clients.validation.codeRequired'),
  name: z.string().min(1, 'clients.validation.nameRequired'),
  type: z.enum(['company', 'individual']),
  taxId: z.string().default(''),
  address: z.string().default(''),
  city: z.string().default(''),
  phone: z.string().default(''),
  email: z.union([z.email(), z.literal('')]).default(''),
  carRegistrationNumber: z.string().max(50).default(''),
  defaultDiscountPct: z.coerce.number().min(0).max(100).default(0),
  paymentTermsDays: z.coerce.number().min(0).default(0),
  notes: z.string().default(''),
});

export type ClientFormData = z.infer<typeof clientSchema>;
